import {
  Checkbox,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { t } from "i18next";
import React from "react";
import { useSelector } from "react-redux";

const FormGeneric = ({
  termini,
  setTermini,
  formData,
  selectList,
  privacy,
  setPrivacy,
  handleChangeRadio,
  consenso,
}) => {
  const appConfig = useSelector((state) => state.app.appConfig);

  return (
    <div className="w-full flex flex-col justify-start mt-5">
      <FormControlLabel
        className="pt-3"
        required
        label={
          <>
            {t("ReadAndAccept")}{" "}
            <a
              href={
                appConfig?.customPolicyAndTerms?.terms
                  ? appConfig?.customPolicyAndTerms?.terms
                  : `${window.location.origin}/${t("terms-and-conditions")}`
              }
              target="_blank"
              rel="noreferrer"
            >
              {t("TermsAndConditions")}
            </a>
          </>
        }
        control={
          <Checkbox checked={termini} onChange={() => setTermini(!termini)} />
        }
      />
      {formData.role === selectList.admin ? (
        <FormControlLabel
          className="pt-3"
          required
          label={
            <>
              {t("ReadAndAccept2")}{" "}
              <a
                href={appConfig?.customPolicyAndTerms?.adminPolicy}
                target="_blank"
                rel="noreferrer"
              >
                privacy policy
              </a>
            </>
          }
          control={
            <Checkbox checked={privacy} onChange={() => setPrivacy(!privacy)} />
          }
        />
      ) : (
        <>
          <FormControlLabel
            className="pt-3"
            required
            label={
              <>
                {t("ReadAndAccept2")}{" "}
                <a
                  href={appConfig?.customPolicyAndTerms?.userPolicy}
                  target="_blank"
                  rel="noreferrer"
                >
                  privacy policy
                </a>
              </>
            }
            control={
              <Checkbox
                checked={privacy}
                onChange={() => setPrivacy(!privacy)}
              />
            }
          />
          {appConfig?.environment === "AISTUDIO" && (
            <div className="mt-2">
              <FormLabel>
                Dichiaro di prestare il consenso al trattamento dei miei dati
                personali, sia semplici che particolari, per le finalità di cui
                al punto 2 dell’informativa privacy dell’App. Il consenso si
                intende liberamente espresso anche nel caso in cui i dati
                personali, sia semplici che particolari, comunicati appartengano
                a membri del mio nucleo familiare, compresi minori degli anni 18
                a mio carico.
              </FormLabel>
              <RadioGroup row value={consenso} onChange={handleChangeRadio}>
                <FormControlLabel
                  control={<Radio />}
                  value={true}
                  label="Presto il consenso"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="Non presto il consenso"
                />
              </RadioGroup>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FormGeneric;
